"use client"

import { InfoIcon } from "@phosphor-icons/react"
import { StarFilledIcon } from "@radix-ui/react-icons"
import { useTranslations } from "next-intl"
import type { HTMLAttributes } from "react"
import { Prose } from "@/components/content/prose"
import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { cn } from "@/utils/cn"

interface MoneyBackNoticeProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function MoneyBackNotice({ className, ...props }: MoneyBackNoticeProps) {
  const t = useTranslations("MoneyBackNotice")

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          size="xs"
          variant="secondary"
          className={cn(
            "inline-flex h-auto gap-x-0.5! rounded-full bg-transparent! py-1 pr-2 pl-2.5 font-medium text-muted-foreground hover:bg-foreground/10!",
            className,
          )}
        >
          <span>{t("button-text")}</span>
          <InfoIcon />
        </Button>
      </PopoverTrigger>

      <PopoverContent side="bottom" className="w-auto max-w-xs rounded-lg p-3" asChild>
        <Prose size="xs" className="prose-p:my-2 prose-p:last:mb-0">
          <div className="mb-3 flex gap-px text-yellow-400 [&_svg]:size-3.5">
            <StarFilledIcon />
            <StarFilledIcon />
            <StarFilledIcon />
            <StarFilledIcon />
            <StarFilledIcon />
          </div>
          <p className="font-bold">{t("title")}</p>
          <p>
            {t.rich("description", {
              em: (chunks) => <em className="whitespace-nowrap">{chunks}</em>,
            })}
          </p>
        </Prose>
      </PopoverContent>
    </Popover>
  )
}
